export default __webpack_public_path__ + "static/media/Rub_placement-15.7e1dd666.png";